import { render, staticRenderFns } from "./BecomeDueIcon.vue?vue&type=template&id=588adb70"
import script from "./BecomeDueIcon.vue?vue&type=script&lang=js"
export * from "./BecomeDueIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports